import CluodCertModalActionTypes from './cloud-cert-modal.types'

export const showCloudCertModal = () => ({
  type: CluodCertModalActionTypes.SHOW_MODAL,
})

export const hideCloudCertModal = () => ({
  type: CluodCertModalActionTypes.HIDE_MODAL
})